<template>
    <div class="tab_wrapper font-responsive">
        <!-- preload -->
        <div style="position: absolute; top: -9999px; left: -9999px; "><img :src="tab.visual.img.src" :alt="tab.visual.img.alt"></div>
        
        <div class="tab_contents">
            <div class="tab_visual w-1/2 mobile:w-full">
                <div class="tab_photo-big">
                    <div class="tab-video-wrapper" :style="'background-image: url('+tab.visual.img.src+');'">
                        <div class="tab-video-loader mobile:hide"></div>
                        <video class="mobile:hide" :src="tab.visual.video.src" :id="'vid-' + tab.id" muted="muted"></video>
                    </div>
                    <transition name="fade">
                        <img v-if="videoAlreadyPlayed" :src="tab.visual.img.src" :alt="tab.visual.img.alt">
                    </transition>
                </div>
            </div>
            <article class="tab_caption w-2/5 mobile:w-full">
                <header>
                    <figure class="tab_icon" v-html="tab.icon" :style="customColor(tab)"></figure>
                    <h2 v-html="tab.title"></h2>
                </header>
                <div class="tab_texts">
                    <p v-for="(text, index) in texts(tab)" v-html="text" :key="index"></p>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
export default {
    props: ['component_data'],
    data(){
        return {
            videoAlreadyPlayed: false,
            tab: {
                "title": "",
                "id": "",
                "icon": "",
                "text": "",
                "visual": {
                    "img": {
                        "src": "",
                        "alt": ""
                    },
                    "video": {
                        "src": ""
                    }
                },
                "component": ""
            }
        }
    },
    methods: {
        customColor(tab){
          if(tab.icon_color) {
            return "color: "+tab.icon_color+";"
          }
        },
        handleScroll: function () {
            if (this.isVideoInViewport()) {
                this.playVideoOnceAndShowImage()
            }
        },
        playVideoOnceAndShowImage: function () {
            let cmp = this
            if (cmp.videoAlreadyPlayed) {
                return
            }

            let video = document.getElementById('vid-' + cmp.tab.id)

            video.onended = function () {
                cmp.videoAlreadyPlayed = true
            }

            const playPromise = video.play();
        
            if (playPromise !== null) {
                playPromise.catch(() => { video.play() })
            }
        },
        isVideoInViewport: function () {
            let video = document.getElementById('vid-' + this.tab.id)
            if (video) {
                var bounding = video.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight + 80 || document.documentElement.clientHeight + 80) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                )
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            Object.assign(this.tab, this.component_data)
            if (this.isVideoInViewport()) {
                this.playVideoOnceAndShowImage()
            }
        })
    },
    created(){
        window.addEventListener('scroll', this.handleScroll);
    }
}
</script>

<style scoped>

    .tab_photo-big .tab-video-wrapper {
        border-top-left-radius: 60px;
        position: absolute;
        overflow: hidden;
        height: 100%;
        width: 100%;
        background-position: center;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .tab-video-loader {
        width: 20px;
        height: 20px;
        position: absolute;
        background-color: rgba(36, 36, 36, 0.6);
        border: solid 4px white;
        border-bottom-color: transparent;
        border-top-color: transparent;
        animation: video-loader-spin 1.4s linear infinite;
        border-radius: 20px;
    }
    @keyframes video-loader-spin {from{transform:rotate(0)}to{transform:rotate(360deg)}}
    .tab_photo-big .tab-video-wrapper video {
        height: 100%;
        max-width: initial;
        position: relative;
    }
    .tab_photo-big::before
    {
        content: '';
        border-bottom-left-radius: 3em;
        right: -3em;
        background: linear-gradient(to right, #AE0B11, #E41429);
    }
    @media (min-width: 1920px){
        .tab_photo-big {
            width: 620px;
            height: 680px;
        }

        .tab_photo-big::before {
            width: 460px;
            height: 285px;            
        }       
    }
    .tab_photo-big img {
        border-top-left-radius: 60px;
        overflow: hidden;   
        position: relative;   
    }

    .tab_wrapper::before { 
        border-top-right-radius: 60px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .8s;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
        }
</style>
